import { GridColDef } from '@mui/x-data-grid-premium';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { AbsenceTableRowCommon } from '~/scenes/PeopleModule/components/Tabs/AbsencesTab/components/AbsencesTable/data/types';
import { capitalizeFirstLetter } from '~/utils/helper';

type PropsType = {
  isHistory?: boolean;
};

export const useCommonAbsenceTableColumnConfigs = <
  TRow extends AbsenceTableRowCommon,
>(
  props: PropsType,
) => {
  const { isHistory } = props;

  const { t } = useTranslation();

  const columnConfigs = useMemo((): GridColDef<TRow>[] => {
    return [
      {
        field: 'reason',
        headerName: t('laAbsenceReason'),
        flex: 1,
        minWidth: 160,
      },
      {
        field: 'year',
        headerName: t('laYear'),
        flex: 0.3,
        minWidth: 60,
      },
      {
        field: 'startDate',
        headerName: t('laStartDate'),
        flex: 0.5,
        minWidth: 100,
      },
      {
        field: 'endDate',
        headerName: t('laEndDate'),
        flex: 0.5,
        minWidth: 100,
      },
      {
        field: 'days',
        headerName: capitalizeFirstLetter(t('laDays')),
        flex: 0.3,
        minWidth: 60,
      },
      {
        field: 'hours',
        headerName: t('laHours'),
      },
      {
        field: 'plannedWorkingHours',
        headerName: t('laPlannedWorkingHours'),
        minWidth: 200,
      },
      {
        field: 'info',
        headerName: t('laInfo'),
        flex: 1.5,
        minWidth: 150,
      },
      {
        field: 'attachment',
        headerName: t('laAttachment'),
        flex: 1,
        minWidth: 200,
      },
      {
        field: 'status',
        headerName: t('laStatus'),
        flex: 0.7,
        minWidth: 300,
      },
      ...(isHistory
        ? [
            {
              field: 'created',
              headerName: t('laCreated'),
              flex: 2,
              minWidth: 260,
            },
          ]
        : [
            {
              field: 'actions',
              headerName: '',
              width: 60,
              hideable: false,
              sortable: false,
              pinnable: false,
              disableColumnMenu: true,
            },
          ]),
    ];
  }, [isHistory, t]);

  return {
    columnConfigs,
  };
};
